import React, { useState } from "react";
import { Modal, ModalBody, Button } from "reactstrap";

const DOCUMENT_TYPES = [
    "Driver License",
    "SSN",
    "Birth Certificate",
    "Passport",
    "Green Card",
    "EAD Card",
    "Arbitration Agreement",
    "Employee Handbook",
    "Notice to Employee Wage Theft",
    "SDI / PFL / UI Pamphlets",
    "NDA Confidentiality Agreement",
    "Employee's Withholding Allowance Certificate",
    "Employee's Withholding Certificate",
    "Employment Eligibility Verification"
];

const wrap = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "12px 16px",
    background: "#3a3a3a",
    borderRadius: 12,
    marginBottom: 10,
    cursor: "pointer",
    border: "1px solid rgba(255,255,255,0.12)"
};

const box = (checked) => ({
    width: 22,
    height: 22,
    borderRadius: 6,
    border: checked ? "2px solid #ffd86b" : "2px solid #888",
    background: checked ? "#ffd86b" : "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: 700,
    fontSize: 14,
    color: "#000",
    transition: ".15s"
});

export default function RequestDocumentSelectorModal({
    isOpen,
    toggle,
    onConfirm
}) {
    const [selected, setSelected] = useState([]);

    const toggleSelect = (doc) => {
        setSelected((prev) =>
            prev.includes(doc)
                ? prev.filter((x) => x !== doc)
                : [...prev, doc]
        );
    };

    const confirm = () => {
        if (selected.length === 0) return;
        onConfirm(selected);
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} contentClassName="custom-dark-modal">
            <ModalBody style={{ background: "#262523", padding: 28, borderRadius: 12 }}>

                <h3 style={{
                    color: "#ffd86b",
                    textAlign: "center",
                    marginBottom: 20,
                    fontWeight: 700
                }}>
                    Select documents to request
                </h3>

                {DOCUMENT_TYPES.map((doc) => (
                    <div key={doc} style={wrap} onClick={() => toggleSelect(doc)}>
                        <div style={box(selected.includes(doc))}>
                            {selected.includes(doc) ? "✓" : ""}
                        </div>
                        <div style={{ color: "white", fontSize: 15, fontWeight: 600 }}>
                            {doc}
                        </div>
                    </div>
                ))}

                <Button
                    onClick={confirm}
                    disabled={selected.length === 0}
                    style={{
                        marginTop: 20,
                        width: "100%",
                        background: "#ffd86b",
                        color: "#000",
                        fontWeight: 700,
                        border: "none",
                        padding: "12px 0",
                        borderRadius: 10,
                        fontSize: 16,
                        opacity: selected.length === 0 ? 0.5 : 1
                    }}
                >
                    Request Selected Documents
                </Button>
            </ModalBody>
        </Modal>
    );
}